import * as React from "react";
import { JsonEditor, githubLightTheme } from "json-edit-react";

type Props = {
  value: unknown;
  onChange: (v: unknown) => void;
};

function PlainTextEditor({
  value,
  onChange,
  onKeyDown,
}: {
  value: string;
  onChange: (v: string) => void;
  onKeyDown: React.KeyboardEventHandler<HTMLTextAreaElement>;
}) {
  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={onKeyDown}
      style={{
        width: "100%",
        height: 260,
        fontFamily: "monospace",
        fontSize: 13,
        lineHeight: 1.4,
        padding: 12,
        borderRadius: 6,
        border: "1px solid #ccc",
      }}
    />
  );
}

export default function FullSchemaEditor({ value, onChange }: Props) {
  const [data, setData] = React.useState<any>(value ?? {});
  React.useEffect(() => setData(value ?? {}), [value]);
  const allowAll = React.useCallback(() => false, []);

  return (
    <div style={{ border: "1px solid #e0e0e0", borderRadius: 8, padding: 12 }}>
      <JsonEditor
        data={data}
        setData={(next) => {
          setData(next);
          onChange(next);
        }}
        restrictEdit={allowAll}
        restrictDelete={allowAll}
        restrictAdd={allowAll}
        restrictDrag={false}
        theme={githubLightTheme}
        TextEditor={PlainTextEditor}
        rootName={""}
      />
    </div>
  );
}
